// Detect environment / which side of the business codebase is running
import os from 'os'
const host = os.hostname()
const cheneyDomains = ['estore-dev.cheneyvroomanflooring.com', 'www.cheneyvroomanflooring.com', 'cheneyvroomanflooring.com']
const cheney = process.env.CHENEY || cheneyDomains.includes(host) || false

const env = process.env.RAILS_ENV.includes('ejw') ? (cheney ? 'EJW-CHENEY' : 'EJW') : 'LAN'

export default env;
